export interface Menu {
	default: MenuModes;
	desktop?: MenuModes;
	tablet?: MenuModes;
	mobile?: MenuModes;
}

export interface MenuModes {
	burger: MenuItem[];
	left: MenuItem[];
	right: MenuItem[];
	center: MenuItem[];
}

export interface MenuItem {
	type: MenuItemType;
	label: string;
	icon: string;
	target: string;
	badge?: number;
}

export enum MenuItemType {
	Home = 'goto_homepage',
	Gallery = 'goto_gallery',
	Favorites = 'goto_favorites',
	New = 'goto_new',
	Downloads = 'goto_downloads',
	Updates = 'goto_updates',
	Parameters = 'goto_parameters',
	Link = 'link',
	Asset = 'asset',
	Folder = 'folder',
	Page = 'page',
	Logo = 'logo',
	BurgerButton = 'burger_btn',
	FavoritesButton = 'favorites_btn',
	DownloadButton = 'download_btn',
	SearchButton = 'search_btn',
	DisplayButtons = 'display_btn',
	ShareButton = 'share_btn'
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/typings/menu.ts